module.exports = __webpack_public_path__ + "static/img/video2.5bbcf741.png";